import i18next from 'i18next';

export function localizedLabel(labelEn: string, labelPl: string): string {
  if (i18next.language === 'pl' && labelPl.length > 0) {
    return labelPl;
  }
  return labelEn;
}
